import type { JSX } from 'react';
import styles from './RetourGeste.module.css';

/**
 * Retour d'un geste qui laisse la personne sur la fiche (restauration,
 * archivage d'un contact…) : une ligne de statut, annoncée par les lecteurs
 * d'écran, qui dit ce qui vient d'arriver — pas le « modifié » générique d'un
 * enregistrement.
 */
export function RetourGeste({ message }: { message: string | null }): JSX.Element | null {
  if (!message) return null;
  return (
    <p className={styles.retour} role="status">
      {message}
    </p>
  );
}
